export default __webpack_public_path__ + "static/services-detailsdv-d427a2d789d8d60795ef53e6800a8733.jpg";